module.exports = __webpack_public_path__ + "static/media/1.154c55e9.png";